/** basic.alarmPlatform */
export default {
    warchMan: "Дежурный",
    connectState: "Статус подключения",
    succeed: "Успешно",
    lose: "Неудачно",
    deviceAllData: "Всего устройств",
    todayAlarm: "Тревог сегодня",
    pushcondition: "Push-ситуация",
    alarmHandleHandrail: "Панель обработки тревог",
    deviceBasiceNews: "Основная информация об устройстве",
    deviceData: "Данные устройства",
    alarmReason: "Причина тревоги",
    alarmReasonPla: "Выберите причину тревоги",
    remark: "Примечание",
    handleAlarm: "Обработать тревогу",
    rest: "Сброс",
    leisure: "Свободен",
    alarmRecords: "Записи тревог",
    video: "Видео",

    table_deviceNumber: "Номер устройства",
    table_alarmTime: "Время тревоги",
    table_address: "Место установки",
    deviceModelNum: "Модель устройства",
    deviceType: "Тип устройства",
    entity: "Организация",

    handle: "Обработать",
    untreatedNews: "Необработанные",
    dutyLog: "Журнал дежурства",
    close: "Закрыть",

    planeImg: "План",
    TwoDMap: "2D-карта",
    threeDMap: "3D-карта",
    threeDModeling: "3D-модель",
    videoWatch: "Видеонаблюдение",
    relevanceVideo: "Устройство — связанное видео",
    dragCom: "Нажмите и удерживайте для перетаскивания",

    timePushRecords: "Записи push за текущее время",
    AliSmS: "Aliyun SMS",
    AliVoice: "Aliyun голос",
    PruvateTelephone: "Выделенная линия",
    appPush: "APP push",

    Mess_selectAlarm: "Сначала выберите событие тревоги!",
    mess_handleAlarmLose: "Не удалось обработать тревогу!",
    mess_handleAlarmSuccess: "Тревога обработана!",
    mess_handleNewAlarm: "Сначала обработайте текущую тревогу!",
    mess_noVideo: "Камера не связана с устройством!",
    rulesHandleWay: "Выберите способ обработки",
    rulesRemark: "Введите примечание",

    selectKey: "Тест кнопки",
    selectSmoke: "Тест дыма",
    selectGas: "Тест газа",
    selectReharsal: "Учения",
    selectFireHazard: "Пожар",
    selectOther: "Другое",
    selectAll: "Все",
    selectUnconfirmed: "Не подтверждено",

    // 报警记录
    alarmRecord_btn: "Назад к записям тревог устройства",
    alarmRecord_searSiteName: "Введите название объекта",
    alarmRecord_SearTypeName: "Введите название типа",
    alarmRecord_alarmAllNum: "Всего тревог",
    alarmRecord_todayAlarm: "Тревоги сегодня",
    alarmRecord_processor: "Обработал",
    alarmRecord_handleTime: "Время обработки",
    alarmRecord_handlingSuggestion: "Рекомендации",
    alarmRecord_histouricalRecord: "История",
    alarmRecord_handleTitle: "Обработка тревоги",
    alarmRecord_selectPla: "Выберите причину тревоги",
    alarmRecord_alarmReason: "Введите примечание к тревоге",
    alarmRecord_handlecomplete: "Обработка завершена!",
    alarmRecord_handleLose: "Ошибка обработки!",
    alarmRecord_check_TypeMessage: "Выберите причину тревоги",
    alarmRecord_alarmRemarks: "Введите примечание к тревоге",

    // 值班日志
    dutyLog_add: "Добавить",
    dutyLog_FillMan: "Заполнил",
    dutyLog_FillContent: "Содержимое",
    dutyLog_attachmentsOne: "Вложение 1",
    dutyLog_attachmentsTwo: "Вложение 2",
    dutyLog_attachmentsThree: "Вложение 3",
    dutyLog_download: "Скачать",
    dutyLog_empty: "Пусто",
    dutyLog_DialogTitle: "Добавить запись",
    dutyLog_addFormLabel: "Содержимое",
    dutyLog_addFormPla: "Введите содержимое",
    dutyLog_addFormRule: "Содержимое не может быть пустым",

    message_alarmLose: "Не удалось получить адрес воспроизведения!",
    message_alarmLoseAndGuanlian:
        "Не удалось получить адрес воспроизведения связанной камеры!",
    message_alarmLoseNOvide:
        "Не удалось получить адрес воспроизведения! И нет связанной камеры",
    message_plangImgLose: "Для этой тревоги нет плана",
    message_noRelevanc: "Камера не связана",
    message_alarmBlockleisure: "Панель приёма свободна, просмотр недоступен",
}

